import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import withModal from "../../components/withModal";
import InputField from "../../components/form/InputField";
import CommonButton from "../../components/commonButton";
import { useToast } from "../../context/TostContext";

const PasswordChangeModal = ({
  onSubmit,
  onClose,
  successMessage = "Password updated successfully",
  errorMessage = "Failed to update password",
  submitButtonText = "Update Password",
  newPasswordLabel = "New Password",
  confirmPasswordLabel = "Confirm Password",
  newPasswordPlaceholder = "Enter New Password",
  confirmPasswordPlaceholder = "Confirm New Password",
}) => {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      new_password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object({
      new_password: Yup.string().required("Password is required").min(6, "Min 6 characters"),
      confirm_password: Yup.string()
        .oneOf([Yup.ref("new_password"), null], "Passwords must match")
        .required("Confirm password is required"),
    }),
    onSubmit: async (values) => {
      if (!onSubmit) {
        toast.error("Submit handler is not configured");
        return;
      }
      setIsLoading(true);
      try {
        await onSubmit(values.new_password);
        toast.success(successMessage);
        onClose();
      } catch (error) {
        toast.error(error?.message || error?.payload?.message || errorMessage);
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Modal.Body>
        <InputField
          className="mb-3"
          label={{ name: newPasswordLabel }}
          input={{
            name: "new_password",
            type: "password",
            value: formik.values.new_password,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            placeholder: newPasswordPlaceholder,
          }}
          validation={{
            isInvalid: formik.touched.new_password && !!formik.errors.new_password,
            message: formik.errors.new_password,
          }}
        />

        <InputField
          className="mb-3"
          label={{ name: confirmPasswordLabel }}
          input={{
            name: "confirm_password",
            type: "password",
            value: formik.values.confirm_password,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            placeholder: confirmPasswordPlaceholder,
          }}
          validation={{
            isInvalid: formik.touched.confirm_password && !!formik.errors.confirm_password,
            message: formik.errors.confirm_password,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <CommonButton variant="outline" title="Cancel" onClick={onClose} type="button" />
        <CommonButton
          variant="primary"
          title={submitButtonText}
          type="submit"
          isLoading={isLoading}
        />
      </Modal.Footer>
    </Form>
  );
};

export default withModal(PasswordChangeModal);